module.exports = __webpack_public_path__ + "img/fish_crab.9a4d6c5a.png";